export interface LanguageStoreType {
  language: Language;
  firstLanguageChangeDone: boolean;
}

export enum Language {
  DE = 'DE',
  EN = 'EN',
}

export const fallBackLanguage = Language.EN;

export type LanguageStorePayload = LanguageStoreType;

export enum LanguageStoreKind {
  INITIAL = 'INITIAL',
  UPDATE_FIRST_CHANGE_DONE = 'UPDATE_FIRST_CHANGE_DONE',
}

export type LanguageStoreAction =
  | {
      type: LanguageStoreKind.INITIAL;
      payload: LanguageStorePayload['language'];
    }
  | {
      type: LanguageStoreKind.UPDATE_FIRST_CHANGE_DONE;
      payload: LanguageStorePayload['firstLanguageChangeDone'];
    };
